/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Read_Only_ColumnInputs */

const en_issue_read_only_column = /** @type {(inputs: Issue_Read_Only_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`column left out: you cannot change it`)
};

/**
* | output |
* | --- |
* | "column left out: you cannot change it" |
*
* @param {Issue_Read_Only_ColumnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_read_only_column = /** @type {((inputs?: Issue_Read_Only_ColumnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Read_Only_ColumnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_read_only_column(inputs)
});